import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../Section';
import { InView } from '../InView';
import { SectionHeadline } from '../SectionHeadline';
import { pulseEditions } from '../../../data/deck';
export function OngoingSection() {
  return <Section id="ongoing" data-id="element-490" data-mp="2z5ztec84cjrt">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_440px] lg:gap-16" data-id="element-491" data-mp="3439q8cxu7xpo">
        <InView data-id="element-492" data-mp="27cqyyzk7q6s0">
          <SectionHeadline lead="Start with one congress." follow="Build something that lasts." data-id="element-493" data-mp="27d964r8ey5ep" />
        </InView>
        <InView delay={0.1} data-id="element-494" data-mp="2bf43xlr4y0nq">
          <p className="text-[15px] leading-[1.7] text-[var(--muted)]" data-id="element-495" data-mp="2bechp1jfhfa4">
            The IVF Pulse could become a recurring initiative in which Ferring facilitates valuable exchanges of
            perspectives within the fertility community. Each new Pulse creates fresh reasons to engage — and a clearer view
            of evolving priorities.
          </p>
        </InView>
      </div>

      <InView delay={0.16} className="mt-12" data-id="element-496" data-mp="kggkb86jt0s">
        <ol className="relative grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-497" data-mp="1n6jrof5giaeb">
          <div aria-hidden="true" className="absolute left-[6%] right-[6%] top-[30px] hidden h-px bg-[var(--fg)]/15 lg:block" data-id="element-498" data-mp="1n4h5y7bc73fe" />
          {pulseEditions.map((edition, i) => <li key={edition.label} className="relative flex flex-col items-start" data-id="element-499" data-mp="1e4aj3utr0r3k" data-mpi={i}>
              <motion.span initial={{
            scale: 0.6,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + i * 0.15,
            duration: 0.45
          }} className={`flex h-[60px] w-[60px] items-center justify-center rounded-full text-[12px] font-extrabold ring-4 ring-[var(--surface)] ${i === 0 ? 'bg-[var(--brand)] text-white' : 'bg-white text-[var(--fg)] ring-[var(--surface)]'}`} data-id="element-500" data-mp="19691lebz0zu7">
                {String(i + 1).padStart(2, '0')}
              </motion.span>
              <p className="mt-4 text-[10.5px] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-501" data-mp="gkg6zs0twrii">{edition.when}</p>
              <p className="mt-1 text-[20px] font-extrabold tracking-[-0.02em] text-[var(--fg)]" data-id="element-502" data-mp="btubl1kzon1p">{edition.label}</p>
              <p className="mt-0.5 text-[13px] text-[var(--muted)]" data-id="element-503" data-mp="3tzyv90r6k3ol">{edition.detail}</p>
            </li>)}
        </ol>
      </InView>

      <InView delay={0.24} data-id="element-504" data-mp="1w6cjzgcotdq">
        <div className="mt-16 rounded-[30px] bg-[var(--fg)] px-6 py-12 text-center sm:px-10" data-id="element-505" data-mp="1xhgq0dpk35d">
          <p className="mx-auto max-w-[20ch] text-[34px] font-extrabold leading-[1.02] tracking-[-0.04em] text-white sm:text-[52px]" data-id="element-506" data-mp="pnl899dmgcg0">
            Big ideas.
            <span className="block text-[var(--brand-lighter)]" data-id="element-507" data-mp="gs5jv7vmypht">Surprisingly small budgets.</span>
          </p>
          <p className="mx-auto mt-6 max-w-[56ch] text-[16px] leading-relaxed text-white/75" data-id="element-508" data-mp="ksz6zz19809n">
            AI allows us to combine specialist life science expertise with production efficiency — delivering bespoke
            campaigns at a fraction of traditional agency costs.
          </p>
          <p className="mx-auto mt-6 max-w-[52ch] text-[15px] font-bold text-white" data-id="element-509" data-mp="2xzxfbyamczu6">
            Start small. Prove the impact. Scale what works.
          </p>
        </div>
      </InView>
    </Section>;
}